import { usePlansContext } from '@mc/plans-ui'
import { PRO_SLOT } from '../../prcng-1266_v1_cm_dual_cta'
import { useMCProExperiment } from './useMCProExperiment'

export const useSelectedPlanIncludesCertificates = () => {
  const { bucket } = useMCProExperiment()
  const { isDuoSelected, isFamilySelected, isFamilyPlusSelected } =
    usePlansContext()
  const proSlot = bucket && bucket !== 'control' ? PRO_SLOT[bucket] : undefined

  return (
    (proSlot === 'family' && isFamilySelected) ||
    (proSlot === 'familyPlus' && isFamilyPlusSelected) ||
    // Must match the "one certificate" Duo column in the variant_3 matrix header.
    (bucket === 'variant_3' && isDuoSelected)
  )
}
